import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import PageWrapper from "../../components/pageWrapper/PageWrapper";

const fetchBlogPosts = async (category) => {
    try {
        const response = await axios.get(`/api/BlogPost/get-blog-by-category/${category}`);
        return response.data || [];
    } catch (error) {
        console.error(`Lỗi khi lấy dữ liệu bài viết cho danh mục ${category}:`, error);
        return [];
    }
};

const About = ({ config }) => {
    const [sections, setSections] = useState([]);

    useEffect(() => {
        const loadBlogPosts = async () => {
            const data = await fetchBlogPosts("ve-bao-ho-lao-dong-minh-xuan");
            const formattedSections = data.map((post) => ({
                title: post.title,
                content: post.content.replace(/<[^>]+>/g, ""), 
                img: post.imageUrl,
            }));
            setSections(formattedSections);
        };

        loadBlogPosts();
    }, []);

    return (
        <PageWrapper title="Về chúng tôi">
            <div className="about-container">
                <h1 className="title">
                    CÔNG TY TNHH SẢN XUẤT THƯƠNG MẠI BẢO HỘ LAO ĐỘNG MINH XUÂN
                </h1>
                <p className="subtitle">Đồng hành cùng sự an toàn của bạn</p>
                {sections.length > 0 ? (
                    sections.map((section, index) => (
                        <div
                            key={index}
                            className={`section ${index % 2 === 1 ? "reverse" : ""}`}
                        >
                            <div className="text-content">
                                <h2 className="section-title">{section.title}</h2>
                                <p className="section-text">{section.content}</p>
                            </div>
                            <img
                                src={section.img}
                                alt={section.title}
                                className="image"
                            />
                        </div>
                    ))
                ) : (
                    <p>Đang tải dữ liệu hoặc không có bài viết nào.</p>
                )}
            </div>
        </PageWrapper>
    );
};

export default About;